import { apiGetAuth, apiPatchAuth, apiPostAuth, apiPutAuth, apiDeleteAuth } from '@/utils/api'
import { API_SUPPORT } from '@/utils/api-url'
import {
  notificationDanger, notificationSuccess
} from '@/utils/notification'
import axios from 'axios'
import { getUserToken } from '@/utils/auth'

const state = () => {
  return {
    detail_order_msi: {},
    detail_order_gm: {},
    stock_shadow: {},
    data_modal_add_edit: {},
    meta_filter: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,
      title: '',
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    }
  }
}

const mutations = {
  SET_DETAIL_ORDER_MSI(state, payload) {
    state.detail_order_msi = payload
  },
  SET_DETAIL_ORDER_GM(state, payload) {
    state.detail_order_gm = payload
  },

  SET_STOCK_SHADOW(state, payload) {
    state.stock_shadow = payload
  },
  SET_DATA_MODAL_ADD_EDIT(state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD(state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER(state, payload) {
    state.meta_filter = payload
  }
}

const actions = {
  async getDetailOrderMSI(context, payload) {
    try {
      const token = getUserToken()
      const response = await axios({
        method: 'GET',
        url: API_SUPPORT.DETAIL_ORDER_MSI(payload),
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
      context.commit('SET_DETAIL_ORDER_MSI', response.data.data)
      // Return success indicator and data for the component to use
      return { success: true, data: response.data.data }
    } catch (error) {
      console.error('API Error:', error.response ? error.response.data : error)
      context.commit('SET_DETAIL_ORDER_MSI', {})
      notificationDanger(error)
      // Return failure indicator for the component to handle
      return { success: false, error }
    }
  },
  async patchOrderMSI(context, payload) {
    try {
      const response = await apiPatchAuth(API_SUPPORT.UPDATEL_ORDER_MSI, payload)
      notificationSuccess('Pathc Order Success')
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getDetailOrderGM(context, payload) {
    try {
      const response = await apiGetAuth(API_SUPPORT.DETAIL_ORDER_GM(payload))
      context.commit('SET_DETAIL_ORDER_GM', response.data.data)
    } catch (error) {
      context.commit('SET_DETAIL_ORDER_GM', {})
      notificationDanger(error)
    }
  },
  async patchOrderGM(context, payload) {
    try {
      const response = await apiPatchAuth(API_SUPPORT.UPDATEL_ORDER_GM, payload)
      notificationSuccess('Pathc Order Success')
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getStockShadow(context, plu) {
    try {
      const response = await apiGetAuth(`${API_SUPPORT.GET_STOCK_SHADOW}?plu=${plu}`)
      context.commit('SET_STOCK_SHADOW', response.data)
      return response.data
    } catch (error) {
      context.commit('SET_STOCK_SHADOW', {})
      notificationDanger(error)
    }
  },

  async createStockShadow(context, payload) {
    try {
      const response = await apiPostAuth(API_SUPPORT.CREATE_STOCK_SHADOW, payload)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },

  async updateStockShadow(context, payload) {
    try {
      const response = await apiPutAuth(API_SUPPORT.UPDATE_STOCK_SHADOW, payload)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },

  async deleteStockShadow(context, payload) {
    try {
      const response = await apiDeleteAuth(API_SUPPORT.UPDATE_STOCK_SHADOW, payload)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  }
}

const getters = {
  detail_order_msi(state) {
    return state.detail_order_msi
  },
  detail_order_gm(state) {
    return state.detail_order_gm
  },
  stock_shadow(state) {
    return state.stock_shadow
  },
  get_toggle_modal_add_edit_discard(state) {
    return state.toggle_modal_add_edit_discard
  },
  get_data_modal_add_edit(state) {
    return state.data_modal_add_edit
  },
  meta_filter(state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
